'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reactTimeAgoFormatters = undefined;

var _de = require('react-timeago/lib/language-strings/de');

var _de2 = _interopRequireDefault(_de);

var _fr = require('react-timeago/lib/language-strings/fr');

var _fr2 = _interopRequireDefault(_fr);

var _nl = require('react-timeago/lib/language-strings/nl');

var _nl2 = _interopRequireDefault(_nl);

var _en = require('react-timeago/lib/language-strings/en');

var _en2 = _interopRequireDefault(_en);

var _it = require('react-timeago/lib/language-strings/it');

var _it2 = _interopRequireDefault(_it);

var _ja = require('react-timeago/lib/language-strings/ja');

var _ja2 = _interopRequireDefault(_ja);

var _zhCN = require('react-timeago/lib/language-strings/zh-CN');

var _zhCN2 = _interopRequireDefault(_zhCN);

var _buildFormatter = require('react-timeago/lib/formatters/buildFormatter');

var _buildFormatter2 = _interopRequireDefault(_buildFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import language files for react-timeago component
var reactTimeAgoFormatters = {
    de: (0, _buildFormatter2.default)(_de2.default),
    fr: (0, _buildFormatter2.default)(_fr2.default),
    en: (0, _buildFormatter2.default)(_en2.default),
    nl: (0, _buildFormatter2.default)(_nl2.default),
    it: (0, _buildFormatter2.default)(_it2.default),
    ja: (0, _buildFormatter2.default)(_ja2.default),
    zh: (0, _buildFormatter2.default)(_zhCN2.default)
};

exports.reactTimeAgoFormatters = reactTimeAgoFormatters;